import { homeNavMuted } from '@/features/home/styles/homeStyles'
import { palettePrimaryMain, surfaceAuthCard } from '@/theme/designTokens'

/** Figma 5133-14373 — provider shell top navigation */
export const providerShellNavHeightPx = 65

export const providerShellNavRootSx = {
  bgcolor: surfaceAuthCard,
  backgroundColor: surfaceAuthCard,
  minHeight: `calc(${providerShellNavHeightPx}px + env(safe-area-inset-top, 0px))`,
  height: `calc(${providerShellNavHeightPx}px + env(safe-area-inset-top, 0px))`,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  px: { xs: 2, sm: 3, md: '40px' },
  pt: 'env(safe-area-inset-top, 0px)',
} as const

export const providerShellNavLogoSx = {
  height: { xs: 32, md: 40 },
  width: 'auto',
  maxHeight: { xs: 32, md: 40 },
  display: 'block',
  objectFit: 'contain',
  objectPosition: 'left center',
  flexShrink: 0,
  mr: { xs: 2, md: 6 },
} as const

export const providerShellNavLinksSx = {
  display: { xs: 'none', md: 'flex' },
  alignItems: 'center',
  gap: 2,
  flex: 1,
} as const

const providerShellNavLinkBaseSx = {
  fontSize: '16px',
  lineHeight: '24px',
  display: 'block',
} as const

export const providerShellNavLinkInactiveSx = {
  ...providerShellNavLinkBaseSx,
  fontWeight: 600,
  color: homeNavMuted,
} as const

export const providerShellNavLinkActiveSx = {
  ...providerShellNavLinkBaseSx,
  fontWeight: 600,
  color: palettePrimaryMain,
} as const

export const providerShellNavLinkWrapSx = {
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: '16px',
  py: '8px',
  boxSizing: 'border-box',
} as const

/** Reserved under every link so active state does not shift layout */
export const providerShellNavLinkIndicatorSlotSx = {
  width: '100%',
  height: 4,
  borderRadius: '4px',
  flexShrink: 0,
} as const

export const providerShellNavActionsSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  ml: 'auto',
  flexShrink: 0,
} as const

/** Shown only while primary links are hidden (below md). */
export const providerShellNavMenuButtonSx = {
  display: { xs: 'inline-flex', md: 'none' },
  width: 36,
  height: 44,
  borderRadius: '10px',
  color: '#0F172A',
  flexShrink: 0,
  mr: 0.5,
  '&:hover': { bgcolor: 'rgba(15, 23, 42, 0.04)' },
} as const

export const providerShellMobileNavSx = {
  width: 200,
  maxWidth: '70vw',
  boxSizing: 'border-box',
  bgcolor: surfaceAuthCard,
  display: 'flex',
  flexDirection: 'column',
  py: 1,
} as const

export const providerShellMobileNavHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  px: 0.5,
  minHeight: 48,
} as const

export const providerShellMobileNavLinkSx = {
  display: 'flex',
  alignItems: 'center',
  minHeight: 48,
  px: 2,
  mx: 1,
  borderRadius: '8px',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 600,
  color: homeNavMuted,
  textDecoration: 'none',
} as const

export const providerShellMobileNavLinkActiveSx = {
  ...providerShellMobileNavLinkSx,
  color: palettePrimaryMain,
  bgcolor: 'rgba(0, 140, 208, 0.08)',
} as const

export const providerShellNavConnectionBannerSx = {
  width: '100%',
  bgcolor: '#FEF3C7',
  borderBottom: '1px solid #FDE68A',
  px: { xs: 2, md: '40px' },
  py: '8px',
  boxSizing: 'border-box',
} as const

export const providerShellNavConnectionBannerTextSx = {
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '20px',
  color: '#92400E',
  textAlign: 'center',
} as const

export const providerShellNavAvatarSx = {
  width: 40,
  height: 40,
  borderRadius: '50%',
  bgcolor: palettePrimaryMain,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '24px',
  flexShrink: 0,
} as const
